/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { css } from '@emotion/react'

import Paragraph from '../paragraph'

import { fillArea, floodBgImage } from '../../styles/css'
import { Cont, VStack } from '../../styles/els'
import { renderHTML } from '../../lib/helpers'

export const LandingSection = (props) => {
  const { hasContent, children } = props

  return (
    <section>
      <div
        sx={{
          pt: [5, null, 8],
          pb: [6, hasContent ? 7 : null, null, hasContent ? 9 : 7],
        }}
      >
        {children}
      </div>
    </section>
  )
}

const Landing = (props) => {
  const { heading, subheading, children, ...otherProps } = props

  return (
    <LandingSection hasContent={!!children}>
      <Cont>
        <Paragraph
          heading={heading}
          hTier={1}
          text={subheading}
          align="center"
        />
        {children}
      </Cont>
    </LandingSection>
  )
}

export default Landing
